<template>
  <v-app>
    <router-view></router-view>
  </v-app>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
/* ============================================
   KES LAKAY - Global Styles
   Minimal, clean foundation
   ============================================ */

/* Import Inter font */
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');

/* CSS Variables */
:root {
  --kl-primary: #194173;
  --kl-secondary: #f68d3b;
  --kl-bg: #f5f7fa;
  --kl-surface: #ffffff;
  --kl-border: #e8ecf1;
  --kl-text: #1a2332;
  --kl-text-secondary: #64748b;
  --kl-radius: 8px;
  --kl-shadow-sm: 0 1px 3px rgba(0, 0, 0, 0.08);
  --kl-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  --kl-shadow-lg: 0 8px 24px rgba(0, 0, 0, 0.12);
  --kl-transition: 0.2s ease;
}

/* Base */
.v-application {
  background-color: var(--kl-bg) !important;
  font-family: 'Inter', 'Roboto', sans-serif !important;
}

/* Page content area */
.page-content {
  padding: 24px;

  @media (max-width: 600px) {
    padding: 16px;
  }
}

/* Page header pattern */
.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 12px;

  .page-title {
    font-size: 1.5rem;
    font-weight: 700;
    color: var(--kl-text);
    margin: 0;
  }

  .page-subtitle {
    font-size: 0.875rem;
    color: var(--kl-text-secondary);
    margin: 0;
  }
}

/* Stat cards */
.stat-card {
  cursor: pointer;
  transition: transform var(--kl-transition), box-shadow var(--kl-transition);
  border: 1px solid var(--kl-border) !important;
  box-shadow: var(--kl-shadow-sm) !important;

  &:hover {
    transform: translateY(-2px);
    box-shadow: var(--kl-shadow-lg) !important;
  }
}

/* Chart containers */
.chart-card {
  border: 1px solid var(--kl-border) !important;
  box-shadow: var(--kl-shadow-sm) !important;
}

/* Status chips */
.status-chip {
  font-weight: 500;
  font-size: 0.75rem;
}

/* Data table clean styles */
.v-data-table {
  border: 1px solid var(--kl-border) !important;
  box-shadow: none !important;
}

/* Dialog actions */
.v-dialog .v-card__actions {
  padding: 16px 24px !important;
}

/* Responsive helpers */
@media (max-width: 600px) {
  .page-header {
    margin-bottom: 16px;

    .page-title {
      font-size: 1.25rem;
    }
  }

  .v-data-table {
    .v-data-table__wrapper {
      overflow-x: auto;
    }
  }
}

/* Fix for v-btn width - prevent full width buttons everywhere */
.v-application .v-btn:not(.v-btn--block) {
  width: auto !important;
}

/* Preloader */
.page-loader {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 300px;
}
</style>
